import React from "react";
import HomePage from "./HomePage";

const SaveoHome = (props) => {
  return <HomePage {...props} />;
};

export default SaveoHome;
